import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      style: {"width":"230px"}
    }, {
      title: _withCtx(() => [
        _createTextVNode("Nova Linha")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args)))
          }, _hoisted_2)
        ])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_form_item, {
                  label: "Quantidade de Colunas",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "ant-input",
                      min: "1",
                      max: "12",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.qtdColunas) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.qtdColunas]
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}